import { gql } from '@apollo/client';
export const GET_REVIEW_QUERY = gql `
  query GetReview($documentId: ID!) {
    review: currentDocumentReview(documentId: $documentId) {
      id
      status
      feedbacks {
        feedback {
          id
          name
          content
          notes
          type
          criticality
          discarded
          playbookSHA256
        }
        playbookRules
      }
    }
  }
`;
